import { connect } from "react-redux";
import { fetchTasks } from "@actions/1_entities/tasks_actions";
import TaskGroupsDrawer from './task_groups_drawer'

const mapStateToProps = (state) => ({
  listTypes: state.configs.task_list_type,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTasks: (params, cb) => dispatch(fetchTasks(params, cb)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupsDrawer);